/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
import {
  FormControl,
  FormControlProps,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as InMarKitSelect,
  SelectProps as InMarkitSelectProps,
} from '@mui/material';
import isEmpty from 'lodash-es/isEmpty';
import isNil from 'lodash-es/isNil';
import React, { ReactNode } from 'react';
import { useController, useFormContext } from 'react-hook-form';

interface SelectProps extends Omit<InMarkitSelectProps, 'onChange'> {
  name: string;
  label: string;
  formControlProps?: FormControlProps;
  options: { value: any; label: any }[];
  rules?: any;
  normalizeOutput?: Function;
  normalizeInput?: Function;
  customLabel?: Function;
  renderValue?: (value: any) => ReactNode;
}

function Select({
  name,
  rules,
  label,
  options,
  formControlProps,
  normalizeOutput = (event) => event,
  normalizeInput = (input) => input,
  customLabel,
  renderValue,
  fullWidth,
  placeholder,
  ...rest
}: SelectProps) {
  const { control, register } = useFormContext();
  const { field, fieldState } = useController({ control, name });
  const labelId = `select-label-${name}`;
  // We want the ref for the error message defined in ProductSchema to work.
  const { ref } = register(name, rules);

  return (
    <FormControl variant="standard" error={Boolean(fieldState.error)} fullWidth={fullWidth} {...formControlProps}>
      {Boolean(label) && <InputLabel id={labelId}>{label}</InputLabel>}
      <InMarKitSelect
        name={name}
        variant="standard"
        size="small"
        labelId={labelId}
        value={isEmpty(options) || isNil(field.value) ? '' : normalizeInput(field.value)}
        onChange={(e) => field.onChange(normalizeOutput(e))}
        ref={ref}
        // If the selected value doesn't exist in the options, then render a placeholder.
        renderValue={
          // The dropdown values can also get converted into a string
          options.find((option) => option.value === field.value || option.value.toString() === field.value?.toString())
            ? renderValue
            : () => placeholder || `Select ${label || 'Value'}`
        }
        // This makes sure we display the placeholder if the value is empty
        displayEmpty
        {...rest}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {(customLabel && customLabel(option, field.value)) || option.label}
          </MenuItem>
        ))}
      </InMarKitSelect>
      {Boolean(fieldState.error) && <FormHelperText>{fieldState.error?.message}</FormHelperText>}
    </FormControl>
  );
}

export default Select;
